import { QRCodeSVG } from 'qrcode.react';
import { Container, Info, TimerDiv } from './styles';
import { TransactionStatus } from '../../../../services/gateway.service';

function InfoMessage({ status, countDown } : { status: string | null, countDown: string }) {
    switch (status) {
        case 'FAILED':
            return (
                <TimerDiv
                    type="error"
                >
                    Ouve um erro no pagamento! Tente novamente
                </TimerDiv>
            );
        case 'EXPIRED':
            return (
                <TimerDiv
                    type="warning"
                >
                    O tempo para pagamento expirou! Tente novamente
                </TimerDiv>
            );
        default:
            return (
                <TimerDiv>
                    Você tem:
                    <span> {countDown} </span>
                    para efetuar a transferência e concluir sua compra
                </TimerDiv>
            )
    }
}

function getTimeLeft(endDate: Date) {
    let timeLeft: string;

    const now = new Date();
    const difference = endDate.getTime() - now.getTime();

    if (difference <= 0) {
        timeLeft = 'Expired';
        return timeLeft;
    }

    // Convert to minutes and seconds
    const minutes = Math.floor(difference / 1000 / 60);
    const seconds = Math.floor((difference / 1000) % 60);
    
    timeLeft = `${minutes}m ${seconds.toString().padStart(2, '0')}s`;

    return timeLeft;
}

export default function QrCountdown({
    codeString,
    endDate,
    transactionStatus,
}: {
    codeString: string;
    endDate: Date;
    transactionStatus: TransactionStatus | null;
}) {
    const countDown = getTimeLeft(endDate);

    return (
        <Container>
            <InfoMessage 
                status={transactionStatus}
                countDown={countDown}
            />
            <QRCodeSVG value={codeString} size={178} />
            <Info>
                Escaneie o QR Code ou copie o código abaixo, cole em seu banco
            </Info>
        </Container>
    );
}
